var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticClass:"text-h2 mr-4"},[_vm._v("$")]),_c('Roller',{staticClass:"roller text-h1",attrs:{"default-value":"0","text":_vm.displayNum,"char-set":_vm.numbers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }